import { Box, FormControl, InputLabel, Select } from "@mui/material";

import styled from "styled-components";

export const TrackerBlock = styled(Box)`
    margin-bottom: 28px;
`;

export const FilterCard = styled(Box)`
    position: relative;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    padding: 20px 24px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FilterHeaderRow = styled(Box)`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
`;

export const SearchBar = styled(Box)`
    max-width: 320px;
    flex: 1 1 320px;

    @media (max-width: 599.95px) {
        flex: 1 1 100%;
        max-width: 100%;
    }

    & .MuiOutlinedInput-root {
        height: 40px;
        box-sizing: border-box;
    }

    & .MuiOutlinedInput-input {
        height: 40px;
        padding-top: 0;
        padding-bottom: 0;
        box-sizing: border-box;
        line-height: 40px;
    }
`;

export const ClearFiltersLink = styled(Box)`
    font-size: 12px;
    font-weight: 600;
    color: #ed6c02;
    cursor: pointer;
    font-family: "Nunito", sans-serif;
    white-space: nowrap;
    flex-shrink: 0;
    margin-left: auto;

    &:hover {
        text-decoration: underline;
    }
`;

export const FilterSelectControl = styled(FormControl)`
    min-width: 200px;
    flex: 1 1 200px;
    max-width: 260px;

    @media (max-width: 599.95px) {
        flex: 1 1 100%;
        min-width: 0;
        max-width: 100%;
    }

    & .MuiOutlinedInput-notchedOutline {
        border-color: #e5e5ea;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
        border-color: #ed6c02;
    }

    & .Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #ed6c02;
    }

    & .MuiOutlinedInput-root {
        height: 40px;
        box-sizing: border-box;
    }
`;

export const FilterSelectLabel = styled(InputLabel)`
    &.MuiInputLabel-root {
        font-family: "Nunito", sans-serif;
    }

    &.Mui-focused {
        color: #ed6c02;
    }
`;

export const FilterSelect = styled(Select)`
    font-family: "Nunito", sans-serif;
    font-size: 13px;
    font-weight: 600;
    height: 40px;
    box-sizing: border-box;

    & .MuiSelect-select {
        display: flex;
        align-items: center;
        height: 40px;
        min-height: 0 !important;
        padding-top: 0;
        padding-bottom: 0;
        box-sizing: border-box;
        overflow: hidden;
    }
`;

export const SelectValueText = styled(Box)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1 1 auto;
`;

export const FilterOptionIcon = styled(Box)`
    width: 20px;
    height: 20px;
    border-radius: 6px;
    background: #f2f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    margin-right: 8px;

    img {
        width: 13px;
        height: 13px;
        object-fit: contain;
    }
`;

export const SelectedFiltersRow = styled(Box)`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    & .MuiChip-root {
        font-family: "Nunito", sans-serif;
        font-weight: 600;
        background: #f2f2f5;
    }

    & .MuiChip-avatar {
        width: 18px;
        height: 18px;
        object-fit: contain;
        background: transparent;
    }
`;

export const TrackerRowHeader = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
`;

export const TrackerNameLabel = styled(Box)`
    display: flex;
    align-items: baseline;
    gap: 6px;
    min-width: 0;
    font-family: "Nunito", sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #6e6e73;
    white-space: nowrap;
`;

export const TrackerNameValue = styled(Box)`
    color: #1d1d1f;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 320px;

    &:hover {
        color: #ed6c02;
        text-decoration: underline;
    }
`;

export const ActionButtonRow = styled(Box)`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`;

export const ViewToggleGroup = styled(Box)`
    display: inline-flex;
    align-items: center;
    background: #f2f2f5;
    border-radius: 4px;
    padding: 3px;
    gap: 2px;
    flex-shrink: 0;
    margin-left: auto;
`;

export const ViewToggleButton = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 32px;
    padding: 0 14px;
    border-radius: 4px;
    cursor: pointer;
    font-family: "Nunito", sans-serif;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    user-select: none;
    color: ${({ $active }) => ($active ? "#1d1d1f" : "#86868b")};
    background: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
    box-shadow: ${({ $active }) =>
        $active ? "0 1px 3px rgba(0, 0, 0, 0.12)" : "none"};
    transition:
        background 150ms ease,
        color 150ms ease,
        box-shadow 150ms ease;

    &:hover {
        color: #1d1d1f;
    }

    svg {
        font-size: 17px;
    }
`;
